import { getPrescriptionLogs } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { PrescriptionLogT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchPrescriptionLogs(
  userId: string,
  dosespotPrescriptionId: string,
  signal?: AbortSignal
): Promise<PrescriptionLogT[]> {
  const config = await createLotusRequestConfig({ signal });
  const response = await getPrescriptionLogs(userId, dosespotPrescriptionId, config);
  return lotusHealthZod.getPrescriptionLogsResponse.parse(response.data) as PrescriptionLogT[];
}
